



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import TubeLabel from '@/lib/form/label/Label.vue';

@Component({
  name: 't-textarea',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    },
    autoResize: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      validator: function(value) {
        // The value must match one of these strings
        return ['bg', 'plain'].indexOf(value) !== -1;
      }
    },
    size: {
      type: String,
      validator: function(value) {
        return ['small', 'medium', 'large', 'xlarge'].indexOf(value) !== -1;
      }
    },
    talign: {
      type: String,
      default: 'left',
      validator: value => {
        return ['left', 'center', 'right'].includes(value);
      }
    },
    invalid: {
      type: Boolean,
      default: false
    },
    invalidMessage: {
      type: String,
      default: ''
    },
    dir: {
      type: String,
      default: 'auto',
      validator: function(value) {
        return ['auto', 'ltr', 'rtl'].indexOf(value) !== -1;
      }
    },
    isAi: {
      type: Boolean,
      default: false
    },
  },
  components: {
    TubeLabel
  },
  model: {
    prop: 'value',
    event: 'update'
  }
})
export default class TTextarea extends Vue {
  disabled!: boolean;
  required!: boolean;
  readonly!: boolean;
  focused = false;
  focus!: boolean;
  autoResize!: boolean;
  name!: string;
  value!: string;
  min!: number;
  max!: number;
  variant!: string;
  size!: string;
  loading!: boolean;
  invalidMessage!: string;
  invalid!: boolean;
  talign!: boolean;
  dir!: string;
  isAi!: boolean;

  private internalValue: string | number | undefined = '';

  mounted() {
    this.internalValue = this.value;
    if (this.autoResize) {
      this.setHeight();
    }
    this.$nextTick(() => {
      if (this.focus) {
        const textarea = this.$refs.textarea as HTMLElement;
        textarea && textarea.focus();
      }
    });
  }

  get classList() {
    return {
      't-textarea': true,
      't-textarea--readonly': this.readonly,
      't-textarea--disabled': this.disabled || this.loading,
      't-textarea--focused': this.focused && !(this.readonly || this.disabled),
      't-textarea--noresize': this.autoResize,
      [`t-textarea--${this.variant}`]: Boolean(this.variant),
      [`t-textarea--${this.talign}`]: Boolean(this.talign),
      [`t-textarea--${this.size}`]: Boolean(this.size),
      't-textarea--invalid': !!this.invalidMessage || this.invalid
    };
  }

  setHeight() {
    const textarea = this.$refs.textarea as HTMLElement;
    if (!textarea) {
      return;
    }
    if (this.autoResize) {
      this.$nextTick(() => {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      });
    }
  }

  onFocus() {
    this.focused = true;
  }

  onClick(event: MouseEvent) {
    this.$emit('click', this.internalValue, event);
  }

  onBlur(event: MouseEvent) {
    this.updateValue(event);
    this.$emit('blur', this.internalValue, event);
    this.focused = false;
  }

  keyup(event: MouseEvent) {
    this.$emit('keyup', this.internalValue, event);
  }

  keydown(event: MouseEvent) {
    this.$emit('keydown', this.internalValue, event);
  }

  onChange(event: KeyboardEvent) {
    const element = event.target as HTMLTextAreaElement;
    this.internalValue = element.value;
  }

  onInput(event) {
    const element = event.target as HTMLTextAreaElement;
    this.internalValue = element.value;
    this.updateValue(event);
    this.$emit('input', this.internalValue);
  }

  updateValue(event: MouseEvent) {
    if (this.internalValue != this.value) {
      this.$emit('update', this.internalValue, event, this.name);
    }
  }

  @Watch('internalValue')
  setHeightOnInternalValue() {
    this.setHeight();
  }

  @Watch('value')
  updateInternalValue(newValue: string) {
    if (this.internalValue != newValue) {
      this.internalValue = newValue;
      this.$emit('update', this.internalValue, event, this.name);
    }
  }

  @Watch('focus')
  onFocussed(newValue: boolean) {
    if (!newValue) {
      return;
    }
    const textarea = this.$refs.textarea as HTMLElement;
    this.$nextTick(() => textarea.focus());
  }

  openAiModal() {
    this.$emit('openAiModal');
  }
}
